export default __webpack_public_path__ + "static/media/553.f47ff55a.gif";